import { AuthStatus } from '$lib/auth';

export interface Page {
  name: string;
  href: string;
  isCurrent: boolean;
  rel?: 'external' | undefined;
  target?: '_tab' | undefined;
  tooltip?: string;
}

const dataExtraPaths = ['/datasets', '/models', '/data/'];

const extraPathsByPage: Record<string, string[]> = {
  '/fleet': [
    '/machine/',
    '/fragment/',
    '/fragments',
    '/modules',
    '/teleop',
    '/dashboard',
  ],
  '/registry': ['/module/', '/ml-model/', '/ml-training/'],
  '/data/all': dataExtraPaths,
};

interface GetPagesOptions {
  currentPathname: string;
  authStatus: AuthStatus;
}

type PageItem = Omit<Page, 'isCurrent'>;
interface PageResults {
  pageLinks: Page[];
  pageButtons: Page[];
}

const getCurrent = (pages: PageItem[], currentPathname: string) =>
  pages.map((page) => ({
    ...page,
    isCurrent: Boolean(
      currentPathname.startsWith(page.href) ||
        extraPathsByPage[page.href]?.some((extraPath) =>
          currentPathname.startsWith(extraPath)
        )
    ),
  }));

export const getPages = ({
  currentPathname,
  authStatus,
}: GetPagesOptions): PageResults => {
  const pageLinks: PageItem[] = [];
  const pageButtons: PageItem[] = [];

  if (authStatus === AuthStatus.Loading) {
    return { pageLinks: [], pageButtons: [] };
  }

  if (authStatus === AuthStatus.LoggedIn) {
    pageLinks.push(
      {
        name: 'Fleet',
        href: '/fleet',
        tooltip:
          'Build, organize, operate, and monitor machines. Manage shared configurations across your fleet.',
      },
      {
        name: 'Data',
        href: '/data/all',
        tooltip:
          'View and manage your data. Curate datasets, label images, and train computer vision models.',
      }
    );
  }

  pageLinks.push({
    name: 'Registry',
    href: '/registry',
    tooltip:
      'Explore community packages that support additional hardware, integrations, and capabilities',
  });
  return {
    pageLinks: getCurrent(pageLinks, currentPathname),
    pageButtons: getCurrent(pageButtons, currentPathname),
  };
};
